import { EUserStatus } from '@/interfaces'

/* eslint-disable sonarjs/no-duplicate-string */
const PWD_FIELD_LABEL = 'Contraseña'

export const SIGNUP_FORM_FIELDS = {
  authPersonalData: {
    label: 'Autorizar tratamiento de datos',
    value: 'authPersonalData',
  },
  authTermsAndConditions: {
    label: 'Autorizar términos y condiciones',
    value: 'authTermsAndConditions',
  },
  birthdate: {
    label: 'Fecha de Nacimiento',
    value: 'birthdate',
  },
  confirmEmail: {
    label: 'Confirmar Email',
    value: 'confirmEmail',
  },
  confirmPassword: {
    label: 'Confirmar Contraseña',
    value: 'confirmPassword',
  },
  email: {
    label: 'Email',
    value: 'email',
  },
  firstName: {
    label: 'Primer Nombre',
    value: 'firstName',
  },
  firstSurname: {
    label: 'Primer Apellido',
    value: 'firstSurname',
  },
  identificationNumber: {
    label: 'Número de Identificación',
    value: 'identificationNumber',
  },
  identificationType: {
    label: 'Tipo de Identificación',
    value: 'identificationTypeId',
  },
  password: {
    label: PWD_FIELD_LABEL,
    value: 'password',
  },
  secondName: {
    label: 'Primer Nombre',
    value: 'secondName',
  },
  secondSurname: {
    label: 'Segundo Apellido',
    value: 'secondSurname',
  },
}

export const USER_FORM_FIELDS = {
  birthdate: {
    label: 'Fecha de Nacimiento',
    value: 'birthdate',
  },
  confirmEmail: {
    label: 'Confirmar email',
    value: 'confirmEmail',
  },
  email: {
    label: 'Email',
    value: 'email',
  },
  firstName: {
    label: 'Primer Nombre',
    value: 'firstName',
  },
  firstSurname: {
    label: 'Primer Apellido',
    value: 'firstSurname',
  },
  identificationNumber: {
    label: 'Número de Identificación',
    value: 'identificationNumber',
  },
  identificationType: {
    label: 'Tipo de Identificación',
    value: 'identificationTypeId',
  },
  roles: {
    label: 'Roles',
    value: 'roles',
  },
  secondName: {
    label: 'Primer Nombre',
    value: 'secondName',
  },
  secondSurname: {
    label: 'Segundo Apellido',
    value: 'secondSurname',
  },
  status: {
    label: 'Estado',
    value: 'status',
  },
}

export const SIGNIN_FORM_FIELDS = {
  password: {
    label: PWD_FIELD_LABEL,
    value: 'password',
  },
  username: {
    label: 'Usuario',
    value: 'username',
  },
}

export const FORGOT_PWD_FORM_FIELDS = {
  email: {
    label: 'Email Registrado',
    value: 'email',
  },
}

export const RESET_PWD_FORM_FIELDS = {
  confirmPassword: {
    label: 'Confirmar Nueva Contraseña',
    value: 'confirmPassword',
  },
  password: {
    label: 'Nueva Contraseña',
    value: 'password',
  },
}

export const PERMISSION_FORM_FIELDS = {
  code: {
    label: 'Código',
    value: 'code',
  },
  deletable: {
    label: 'Borrable',
    value: 'deletable',
  },
  description: {
    label: 'Descripción',
    value: 'description',
  },
  modifiable: {
    label: 'Modificable',
    value: 'modifiable',
  },
  name: {
    label: 'Nombre',
    value: 'name',
  },
  onlyDev: {
    label: 'Tipo de uso',
    value: 'onlyDev',
  },
  preRequired: {
    label: 'Permiso(s) requerido(s)',
    value: 'preRequired',
  },
  type: {
    label: 'Tipo',
    value: 'type',
  },
}

export const MENU_ITEM_FORM_FIELDS = {
  icon: {
    label: 'Icono',
    value: 'icon',
  },
  key: {
    label: 'Key',
    value: 'key',
  },
  label: {
    label: 'Etiqueta',
    value: 'label',
  },
  order: {
    label: 'Orden',
    value: 'order',
  },
  parent: { label: 'Padre', value: 'parent' },
  url: {
    label: 'URL path',
    value: 'url',
  },
}

export const ROUTE_FORM_FIELDS = {
  default: {
    label: 'Por defecto',
    value: 'default',
  },
  description: {
    label: 'Descripción',
    value: 'description',
  },
  menuItem: {
    label: 'Menú',
    value: 'menuItemId',
  },
  method: {
    label: 'Método',
    value: 'method',
  },
  name: {
    label: 'Nombre',
    value: 'name',
  },
  path: {
    label: 'Path',
    value: 'path',
  },
  permission: {
    label: 'Permiso',
    value: 'permissionId',
  },
  private: {
    label: 'Privada',
    value: 'private',
  },
}

export const ROLE_FORM_FIELDS = {
  deletable: {
    label: 'Borrable',
    value: 'deletable',
  },
  description: {
    label: 'Descripción',
    value: 'description',
  },
  modifiable: {
    label: 'Modificable',
    value: 'modifiable',
  },
  name: {
    label: 'Nombre',
    value: 'name',
  },
}

export const USER_STATUS_OPTIONS = [
  {
    label: 'Inactivo',
    value: EUserStatus.DISABLED,
  },
  {
    label: 'Activo',
    value: EUserStatus.ENABLED,
  },
]
